import React from 'react';
import { useLocation } from 'react-router';

import { Chip } from '@mui/material';

import useLoginDialog from 'hooks/use-login-dialog';
import { LockIcon } from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    count: number;
}

const MoreTagsChip: React.FC<Props> = ({ count }) => {
    const { classes } = useStyles();
    const location = useLocation();
    const [dialog, openDialog] = useLoginDialog(location.pathname + location.search);

    return (
        <>
            <Chip
                clickable
                onClick={openDialog}
                label={
                    <>
                        <LockIcon />
                        <span className={classes.bold}>{`+ ${count}`}</span> {'more tags'}
                    </>
                }
                classes={{ root: classes.root, label: classes.label }}
            />
            {dialog}
        </>
    );
};

export default MoreTagsChip;
